import WithGASetup from '../../components/WithGASetup';
import RegistrationPage from './RegistrationPage.js';

export default WithGASetup(RegistrationPage);
